import IconAsMaskImage from '../IconAsMaskImage'

function Play({ pureSvg, className, ...rest }) {
  const svg = (
    <svg {...rest} xmlns="http://www.w3.org/2000/svg" width="13" height="14" viewBox="0 0 13 14" fill="none">
      <path
        d="M3.01053 0.830471C2.01058 0.242261 0.75 0.963241 0.75 2.12337V11.8781C0.75 13.0382 2.01058 13.7592 3.01053 13.171L11.3021 8.29363C12.288 7.71367 12.288 6.28782 11.3021 5.70784L3.01053 0.830471Z"
        fill="white"
      />
    </svg>
  )

  if (pureSvg) return svg

  return <IconAsMaskImage {...{ svg, className }} />
}

export default Play
